export default "__VITE_PUBLIC_ASSET__f71a6531__"